// Convención del proyecto: números con coma decimal en pantalla (98,4 kg).
export function formatNumber(value: number | null | undefined, decimals = 1): string {
  if (value == null) return "—";
  return value.toLocaleString("es-ES", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function formatDate(iso: string): string {
  return new Date(iso + "T00:00:00").toLocaleDateString("es-ES", { day: "2-digit", month: "short" });
}
